import React from 'react';
import { Table } from 'react-bootstrap';
import './Style.scss';

const AttendanceSheetReportFilterDataTable = ({ attendances, grandTotals }) => {
  const renderTotals = (totals, label) => {
    if (!totals) return null;

    return (
      <tr className="totals-row">
        <td colSpan="2" style={{ fontWeight: 'bold' }}>
          {label}
        </td>
        <td colSpan="4" style={{ fontWeight: 'bold' }}>
          Turnos Trabajados (L-S): {totals.total_worked_days_mon_sat}
          {totals.total_worked_days_sun > 0 && ` , Total Semana = ${totals.total_days_week}`}
        </td>
        <td>{totals.total_worked_hours || '00:00:00'}</td>
        <td>{totals.total_delays || '00:00:00'}</td>
        <td>{totals.total_early_departures || '00:00:00'}</td>
        <td>{totals.total_absences || '00:00:00'}</td>
        <td>{totals.total_overtime_50 || '00:00:00'}</td>
        <td>{totals.total_overtime_approved || '00:00:00'}</td>
      </tr>
    );
  };

  const renderGrandTotals = () => {
    if (!grandTotals) return null;

    return (
      <tr className="totals-row grand-totals-row">
        <td colSpan="2" style={{ fontWeight: 'bold', textAlign: 'right' }}>
          Totales Generales
        </td>
        <td colSpan="4" style={{ fontWeight: 'bold' }}>
          {grandTotals.worked_days_text}
        </td>
        <td>{grandTotals.total_hours_worked || '00:00:00'}</td>
        <td>{grandTotals.total_minutes_late || '00:00:00'}</td>
        <td>{grandTotals.total_minutes_early_departure || '00:00:00'}</td>
        <td>{grandTotals.total_hours_non_worked || '00:00:00'}</td>
        <td>{grandTotals.total_minutes_hours_extra || '00:00:00'}</td>
        <td>{grandTotals.total_overtime_approved || '00:00:00'}</td>
      </tr>
    );
  };

  const renderWeekData = (weekData, weekIndex) => {
    if (!weekData || !weekData.attendances) return null;

    const weekTotals = weekData.total_times && weekData.total_times.length > 0 ? weekData.total_times[0] : null;

    return (
      <React.Fragment key={`week-${weekIndex}`}>
        {weekData.attendances.map(day => (
          <tr key={`day-${weekIndex}-${day.date_formatted}`}>
            <td className="text-center align-middle">{day.day_name}</td>
            <td className="text-center align-middle">{day.date_formatted}</td>
            <td className="text-center align-middle">{day.shift_start || '-'}</td>
            <td className="text-center align-middle">{day.shift_end || '-'}</td>
            <td className="text-center align-middle">{day.real_arrival || '-'}</td>
            <td className="text-center align-middle">{day.real_departure || '-'}</td>
            <td className="text-center align-middle">{day.worked_hours || '00:00:00'}</td>
            <td className="text-center align-middle">{day.delays || '00:00:00'}</td>
            <td className="text-center align-middle">{day.early_departures || '00:00:00'}</td>
            <td className="text-center align-middle">{day.absences || '00:00:00'}</td>
            <td className="text-center align-middle">{day.overtime_50 || '00:00:00'}</td>
            <td className="text-center align-middle">{day.overtime_approved || '00:00:00'}</td>
          </tr>
        ))}
        {renderTotals(weekTotals, `Sub-Total Semanal`)}
      </React.Fragment>
    );
  };

  return (
    <div className="attendance-sheet-detail-table">
      <Table className="custom-data-table" bordered size="sm" style={{ fontWeight: 400 }}>
        <thead className="rdt_TableHeadRow" style={{ backgroundColor: '#EBEBEB', textTransform: 'uppercase' }}>
          <tr>
            <th rowSpan="2">Día</th>
            <th rowSpan="2">Fecha</th>
            <th colSpan="2">Jornada Pactada</th>
            <th colSpan="2">Marcas Reales</th>
            <th rowSpan="2">Horas Trabajadas</th>
            <th colSpan="3">Descuentos</th>
            <th colSpan="2">Horas Extras</th>
          </tr>
          <tr>
            <th>Entrada</th>
            <th>Salida</th>
            <th>Entrada</th>
            <th>Salida</th>
            <th>Atrasos</th>
            <th>Salidas Anticipadas</th>
            <th>Ausencias</th>
            <th>50 %</th>
            <th>Aprobadas</th>
          </tr>
        </thead>
        <tbody>
          {attendances && attendances.length > 0 ? (
            <>
              {attendances.map((week, index) => renderWeekData(week, index))}
              {renderGrandTotals()}
            </>
          ) : (
            <tr>
              <td colSpan="10" className="text-center">
                No hay datos de asistencia para mostrar
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default AttendanceSheetReportFilterDataTable;
